import { Link } from 'react-router-dom'

export default function RainmakersLogo() {
  return (
    <Link to="/">
      <img className="mx-auto h-32 w-auto cursor-pointer" src="/images/logo-pink.png" alt="Rainmakers Logo" />
    </Link>
  )
}
